import { render, staticRenderFns } from "./DiscontinuedModal.vue?vue&type=template&id=04038fa7"
import script from "./DiscontinuedModal.vue?vue&type=script&lang=js"
export * from "./DiscontinuedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports